exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".admin-tool-bar[data-v-602af32e]{background-color:#62626c}.admin-tool-bar__body[data-v-602af32e]{display:flex;width:1140px;align-items:center;justify-content:space-between;padding:4px 10px 4px;margin:0 auto}", ""]);

// exports
